/**
 * Created by WebStorm.
 * User: liulin
 * Date: 2018/9/26
 * Time: 上午11:29
 */
import link from './link'
import image from './image'
import codeBlock from './code-block'

export const TOPBAR_CUSTOMIZE = [
  link,
  codeBlock,
  image
]



// WEBPACK FOOTER //
// ./src/components/quill/toolbar/index.js